// extracted by mini-css-extract-plugin
export var growableInput = "_8t-0";
export var tagContainer = "_8t-2";
export var textInput = "_8t-1";